import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredFeature = null }) => {
  const { user, hasFeature, isLoading, logout, isTokenExpired } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; 
  }

  // Verify if the token is valid
  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    logout(); // Logs out if token is invalid or expired
    return <Navigate to="/login" />;
  }

  if (!user) return <Navigate to="/login" replace />;

  if (requiredFeature && !hasFeature(requiredFeature))
    return <Navigate to="/" replace />;

  return children;
};

export default PrivateRoute;